export const lightStyles = {
  loginContainer: {
    textAlign: 'center',
    mb: 6,
  },

  welcomeTitle: {
    fontFamily: '"Inter", "Assistant", sans-serif',
    fontWeight: 700,
    mb: 1,
    color: '#1d1d1f',
    fontSize: { xs: '28px', sm: '34px', md: '40px' },
    lineHeight: '1.3em',
    letterSpacing: '-0.03em',
    maxWidth: '500px',
    mx: 'auto',
  },

  welcomeSubtitle: {
    fontFamily: '"Inter", "Assistant", sans-serif',
    color: '#1d1d1f',
    fontSize: { xs: '15px', sm: '17px' },
    fontWeight: 400,
    lineHeight: 1.4,
    letterSpacing: '-0.01em',
    mb: 0.5,
    maxWidth: '500px',
    mx: 'auto',
  },

  loginCard: {
    p: { xs: 3, sm: 4 },
    backgroundColor: 'rgb(241, 244, 246)',
    color: '#1A1A1A',
    textAlign: 'center',
    border: 'none',
    boxShadow: 'none',
    maxWidth: 480,
    mx: 'auto',
    position: 'relative',
    borderRadius: '16px',
  },

  loginTextField: {
    '& .MuiOutlinedInput-root': {
      color: '#1A1A1A',
      borderRadius: '12px',
      backgroundColor: '#FFFFFF',
      '& fieldset': {
        borderColor: '#E5E7EB',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: '#D1D5DB',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#4F6BF6',
        borderWidth: '1.5px',
      },
    },
    '& .MuiInputLabel-root': {
      color: '#9CA3AF',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#4F6BF6',
    },
  },

  loginCheckbox: {
    color: '#D1D5DB',
    '&.Mui-checked': {
      color: '#4F6BF6',
    },
  },

  loginLink: {
    color: '#6B7280',
    textDecoration: 'none',
    fontSize: '0.875rem',
    '&:hover': {
      color: '#1A1A1A',
    },
  },

  loginPrimaryButton: {
    height: '52px',
    borderRadius: '999px',
    backgroundColor: '#4F6BF6',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: '1rem',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3B5AE6',
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: '#B4C0F9',
      color: '#FFFFFF',
    },
  },

  loginSecondaryButton: {
    height: '48px',
    borderRadius: '999px',
    color: '#FFFFFF',
    backgroundColor: '#8B8B8B',
    border: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#737373',
      boxShadow: 'none',
    },
  },

  loginErrorAlert: {
    borderRadius: '12px',
    backgroundColor: 'rgba(220, 38, 38, 0.08)',
    color: '#DC2626',
    '& .MuiAlert-icon': {
      color: '#DC2626',
    },
  },

  loginSignupLink: {
    color: '#1A1A1A',
    fontWeight: 600,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  // Divider with "or sign in with" text
  loginDivider: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    my: 1,
    '&::before, &::after': {
      content: '""',
      flex: 1,
      height: '1px',
      backgroundColor: '#E5E7EB',
    },
  },
};
